<template>
  <v-app>
    <LoginHeader/>
  </v-app>
</template>

<script>
import LoginHeader from '@/components/Login/LoginHeader';

export default {
  name: "Login",
  components: {LoginHeader},
  mounted() {
    if(this.$store.getters.user.loggedIn) {
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style scoped>

</style>
